/**
 * Portal Manta · ComparaTab
 * Extraído de App.jsx v29.3 (via AST)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { CONSOL_FIN } from '../../data/consol-fin.js';
import { Fonte } from '../shared/ArtefatoHelpers.jsx';
import { V, S, fmtNum, sumBy, sigKey, fmtBRL, isAmpliacao, AmpliBadge } from '../../globals.js';
import { SectionCollapse } from './SectionCollapse.jsx';
import { THl, TH, TDl, TD } from '../../app-globals.js';

function ComparaTab({lote}){
  const sig = sigKey(lote);
  const cp = lote.dados_manta?.compara_parametrico||{};
  const itens = (cp.itens||[]).filter(isAmpliacao);
  const fa = cp.fator_atualizacao||1;
  const consol = CONSOL_FIN[sig]||{};
  const totSicro = Object.values(consol).reduce((s,arr)=>s+sumBy(arr,'v'),0);
  const totPR = itens.filter(it=>it.codigo.split('.').length===3).reduce((s,it)=>s+(it.pr_vias?.preco_total||0),0);
  return(<div style={S.page}>
    <div style={S.h1}>6.1 · Compara Paramétrico · {lote.nome}</div> <AmpliBadge/>
    <div style={S.sub}>
      Comparativo <b>PR Vias × Manta (a ser construído)</b> · {itens.length} itens · Fator atualização: <b>{fa.toFixed(4)}</b>
    </div>

    {/* Quadro-resumo: tabela de totais (era cards) */}
    <div style={{...S.card,overflow:'hidden',marginBottom:14}}>
      <div style={{padding:'7px 12px',fontSize:10.5,fontWeight:700,color:V.br,background:V.g0,borderBottom:'1px solid '+V.b1}}>
        Resumo de totais
      </div>
      <table style={{width:'100%',borderCollapse:'collapse',fontSize:10.5}}>
        <thead style={S.thRow}><tr style={{borderBottom:'2px solid '+V.b1}}>
          <th style={THl}>Fonte</th>
          <th style={TH}>Total (R$)</th>
          <th style={THl}>Observação</th>
        </tr></thead>
        <tbody>
          <tr style={S.trLine}>
            <td style={{...TDl,fontWeight:700,color:V.br}}><span style={{display:'inline-block',width:9,height:9,borderRadius:99,background:V.bl,marginRight:7}}/>PR Vias</td>
            <td style={{...TD,fontWeight:700,color:V.br}}>{fmtBRL(totPR)}</td>
            <td style={{...TDl,color:V.gr}}>Top-level (3 níveis) · oficial do MEF</td>
          </tr>
          <tr style={S.trLine}>
            <td style={{...TDl,fontWeight:700,color:V.or}}><span style={{display:'inline-block',width:9,height:9,borderRadius:99,background:V.or,marginRight:7}}/>Manta</td>
            <td style={{...TD,fontWeight:700,color:V.gr,fontStyle:'italic'}}>—</td>
            <td style={{...TDl,color:V.or,fontStyle:'italic'}}>A ser construído</td>
          </tr>
        </tbody>
        <tfoot>
          <tr style={{borderTop:'2px solid '+V.br,background:V.g0}}>
            <td style={{...TDl,fontWeight:800,color:V.br}}>Δ Manta vs PR Vias</td>
            <td style={{...TD,fontWeight:800,color:V.gr}}>—</td>
            <td style={{...TDl,color:V.gr,fontStyle:'italic'}}>aguardando preenchimento do orçamento Manta</td>
          </tr>
        </tfoot>
      </table>
    </div>

    {/* Tabela de itens — só PR Vias + Manta */}
    <SectionCollapse id="itens" titulo="Itens — comparativo por linha (PR Vias × Manta)" defOpen>
    <div style={{...S.card,overflow:'hidden'}}>
      <div style={{maxHeight:'calc(100vh - 460px)',overflowY:'auto'}}>
        <table style={{width:'100%',borderCollapse:'collapse',fontSize:10.5}}>
          <thead style={S.thRow}><tr style={{borderBottom:'2px solid '+V.b1}}>
            <th style={{...THl,width:80}}>Código</th>
            <th style={THl}>Descrição</th>
            <th style={TH}>Und</th>
            <th style={TH}>Qtde</th>
            <th style={TH}>PR Vias</th>
            <th style={TH}>Manta</th>
            <th style={TH}>Δ Manta/PR</th>
          </tr></thead>
          <tbody>
            {itens.map((it,i)=>{
              const pr = it.pr_vias?.preco_total;
              const lvl = it.codigo.split('.').length;
              const indent = (lvl-3)*14;
              return(<tr key={i} style={{...S.trLine,background:it.is_group?V.g0:'transparent'}}>
                <td style={{...TDl,fontFamily:'monospace',paddingLeft:10+indent}}>{it.codigo}</td>
                <td style={{...TDl,fontWeight:it.is_group?700:500,color:it.is_group?V.br:V.g5}}>{it.descricao}</td>
                <td style={{...TD,fontSize:9.5,color:V.gr}}>{it.unidade||'—'}</td>
                <td style={TD}>{it.qtde!=null?fmtNum(it.qtde,2):'—'}</td>
                <td style={{...TD,fontWeight:it.is_group?700:500,color:V.br}}>{pr!=null?fmtBRL(pr):'—'}</td>
                <td style={{...TD,color:V.gr,fontStyle:'italic'}}>—</td>
                <td style={{...TD,color:V.gr}}>—</td>
              </tr>);
            })}
          </tbody>
          <tfoot>
            <tr style={{borderTop:'2px solid '+V.br,background:V.g0}}>
              <td colSpan={4} style={{padding:'8px 10px',fontSize:11,fontWeight:800,color:V.br}}>TOTAL (top-level)</td>
              <td style={{padding:'8px 10px',fontSize:11,fontWeight:800,textAlign:'right',color:V.br}}>{fmtBRL(totPR)}</td>
              <td style={{padding:'8px 10px',fontSize:11,fontWeight:800,textAlign:'right',color:V.gr,fontStyle:'italic'}}>—</td>
              <td style={{padding:'8px 10px',fontSize:11,fontWeight:800,textAlign:'right',color:V.gr}}>—</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
    </SectionCollapse>
    <SectionCollapse id="cross" titulo="Cross-reference com SICRO consolidado (apenas referência)" defOpen={false}>
    <div style={{...S.cardP,fontSize:11,lineHeight:1.5}}>
      <p style={{marginBottom:8,color:V.br}}>
        SICRO c/ BDI = <b>{fmtBRL(totSicro)}</b> · 
        PR Vias = <b>{fmtBRL(totPR)}</b> · 
        Δ SICRO/PR = <b style={{color:totSicro<totPR?V.gn:V.or}}>{((totSicro/totPR-1)*100).toFixed(2)}%</b>
      </p>
      <p style={{color:V.gr,fontSize:10}}>
        SICRO está consolidado no nível disciplina (Pavimentação, Terraplenagem, etc.). PR Vias está estruturado em hierarquia 1.x.x.x do MEF. Mapeamento direto requer cruzamento código MEF → disciplina SICRO. Esta seção é apenas referência — a comparação principal é PR Vias × Manta (acima).
      </p>
    </div>
    </SectionCollapse>
  </div>);
}

export { ComparaTab };
export default ComparaTab;
